export default __webpack_public_path__ + "static/media/excelIcon.6d466b5a.svg";